import React from 'react';
// import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppRouter from './AppRouter';
import { BrowserRouter as Router } from 'react-router-dom';


const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<Router> <AppRouter /></Router>);

// ReactDOM.render(
//   <Router>
//     <AppRouter />
//   </Router>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
